import Interface from "./Interfaceable.js";

const BreaksInterface = new Interface("SocketListener", [
	"connect",
	"schedule_break_request_approved",
	"schedule_break_request_rejected",
]);

export default BreaksInterface;
